import { FC, lazy, Suspense, useMemo } from 'react'
import * as Sentry from '@sentry/react'
import { Landing } from './landing/Landing'
import { AppContext, useAppContext } from './AppContext'
import { Cutter } from './cutter/Cutter'
import { UploadForm } from './upload/UploadForm'
import { UploadDrop } from './upload/UploadDrop'
import { UploadDropZone } from './upload/UploadDropZone'
import { Toaster } from 'react-hot-toast'
import { visitInfo } from './functions/getVisitInfo'
import { logger } from './logger/logger'
import { LogActionType } from 'api/logs/log-action-type'
import { Import } from './Import'
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

i18n.use(initReactI18next).init({
  lng: 'en',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
})

const Feedback = lazy(() => import('./feedback/Feedback'))

if (visitInfo.user.new) {
  logger.log(LogActionType.NewUser)
}

if (visitInfo.session.new) {
  logger.log(LogActionType.NewSession)
}

logger.log(LogActionType.NewHit)

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://d7e24727a7d14fbab7c9915e6d7052a1@o4505043071533056.ingest.sentry.io/4505043082084352',
    allowUrls: ['https://audiocutter.online'],
  })
}

export const App: FC = () => {
  const contextValue = useAppContext()
  const { audioBuffer, filename, dragging, uploadOpened, feedbackOpened } = contextValue
  const key = useMemo(() => audioBuffer && Date.now(), [audioBuffer])

  return (
    <>
      <AppContext.Provider value={contextValue}>
        {audioBuffer && filename ? <Cutter audioBuffer={audioBuffer} filename={filename} key={key} /> : <Landing />}

        {feedbackOpened && (
          <Suspense fallback={null}>
            <Feedback />
          </Suspense>
        )}

        {uploadOpened ? <UploadForm /> : dragging ? <UploadDrop /> : null}

        {dragging && <UploadDropZone />}

        <Import />
      </AppContext.Provider>

      <Toaster
        toastOptions={{
          style: {
            padding: '0.25rem 0.5rem',
            boxShadow: '0 2px 3px rgba(0, 0, 0, 0.2)',
            borderRadius: '0.25rem',
            fontSize: 15,
          },
        }}
      />
    </>
  )
}
